// 通用金额格式化与解析工具：千分位逗号显示，内部值保持为纯数字

// 将数字字符串增加千分位逗号
export const addThousandsSeparator = (str) => {
  if (str === undefined || str === null) return '';
  const s = String(str);
  // 保留负号与整数部分
  const [sign, body] = s.startsWith('-') ? ['-', s.slice(1)] : ['', s];
  // 拆分整数与小数部分
  const [intPart, decPart] = body.split('.');
  const withComma = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return decPart ? sign + withComma + '.' + decPart : sign + withComma;
};

// Antd InputNumber 的 formatter：把内部数值显示为千分位
export const amountFormatter = (value) => {
  if (value === undefined || value === null || value === '') return '';
  return addThousandsSeparator(String(value));
};

// Antd InputNumber 的 parser：把带逗号的字符串还原为原始数字字符串
export const amountParser = (value) => {
  if (!value) return value;
  return String(value).replace(/,/g, '');
};

// 通用文本展示格式化（例如 Descriptions 等）
export const formatAmountText = (num) => {
  if (num === undefined || num === null || num === '') return '-';
  return addThousandsSeparator(String(num));
};

